import React, { useState, useEffect } from 'react';
import LoginPage from './components/LoginPage';
import './App.css';
import DashboardPage from './components/DashboardPage';
import { API_BASE } from './config/api';
import client from './mqttService'; // ← wss://mqtt.lumieresdejardin.fr:8084/mqtt

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  console.log('Nouveau build !');

  // Vérifie la session au chargement
  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch(`${API_BASE}/user/check_session.php`, {
          credentials: 'include'
        });
        if (!res.ok) throw new Error('Erreur réseau');
        const data = await res.json();
        if (data.loggedIn && data.user) {
          setAuthenticated(true);
          setUserData(data.user); // contient id, username, email, role
        }
      } catch (err) {
        setError('Impossible de vérifier la session');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    checkSession();
  }, []);

  // Lifecycle MQTT : ne PAS terminer la connexion pendant le rendu
  // MQTT.js gère la reconnexion automatiquement via reconnectPeriod — pas besoin d’appel manuel
  // L’appel client.reconnect() sur état CLOSING déclenchait "WebSocket already in CLOSING or CLOSED"

  // Fermer proprement seulement si l’onglet se ferme
  useEffect(() => {
    if (!client) return;
    const onUnload = () => {
      try { client.end(true); } catch {}
    };
    window.addEventListener('beforeunload', onUnload);
    return () => window.removeEventListener('beforeunload', onUnload);
  }, []);

  // Gestion d'erreur globale MQTT (ok)
  useEffect(() => {
    if (!client) return;
    const onError = (err) => {
      console.error('[MQTT][App] Erreur de connexion MQTT :', err);
    };
    client.on('error', onError);
    return () => {
      client.off('error', onError);
    };
  }, []);

  const handleLogin = async (user, role) => {
    setAuthenticated(true);
    // Valeur immediate (evite un flash sans nom d'utilisateur), puis
    // rafraichie tout de suite avec l'objet complet (id, frozen, etc.)
    // que login.php ne renvoie pas encore integralement.
    setUserData({ username: user, role: role || 'owner' });
    try {
      const res = await fetch(`${API_BASE}/user/check_session.php`, { credentials: 'include' });
      const data = await res.json();
      if (data.loggedIn && data.user) setUserData(data.user);
    } catch {}
  };

  const handleLogout = () => {
    setAuthenticated(false);
    setUserData(null);
    // Ne PAS faire client.end(true) ici : ça casse le singleton et provoque
    // "client disconnecting" pendant que le UI se met à jour.
    // Si tu veux vraiment tout réinitialiser : window.location.reload();
  };

  if (loading) {
    return (
      <div className="loading-page">
        <h2>Chargement...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-page">
        <h2>Erreur</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Réessayer</button>
      </div>
    );
  }

  const isGuest = userData?.role === 'guest';
  const hasInviteToken = !!new URLSearchParams(window.location.search).get('invite');

  return (!authenticated || hasInviteToken) ? (
    <LoginPage onLogin={handleLogin} />
  ) : (
    <DashboardPage
      user={userData}
      onLogout={handleLogout}
      isGuest={isGuest}
    />
  );
}

export default App;
